import { Container } from '@wikia/dependency-injection';
import { WINDOW } from './symbols';

export function createContainer(): Container {
	const container = new Container();
	container.bind<Window>(WINDOW).value(window);
	return container;
}
